































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import { NotificationModule } from '@/app/store/modules/notifications'
import ModalAdd from './ModalAdd.vue'

@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
    'modal-add': ModalAdd,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public clearRowSelected
  @Prop({}) public textSearch

  // delete data
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    NotificationModule.deleteNotification({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }

  public modalDelete = {
    id: 'modal-deletes',
  }

  // multipe delete
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  public resetModalAdd: boolean = false
  public funcResetModal() {
    this.$root.$emit('bv::show::modal', 'add-notification')
    if (this.resetModalAdd === false) {
      this.resetModalAdd = true
    } else {
      this.resetModalAdd = false
    }
  }
}
